<div class="container text-center">

  <h1 class="text-danger" style="font-size: 136px;">404 NOT FOUND</h1>
</div>
